<template>

  <modalo
    :title="role.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => role">

    <form
      id="role-form"
      v-on:submit.prevent="saveRole(role)">

      <div
        v-if="!resourceAvailability.features.includes('custom_roles')"
        class="alert alert-warning">Para editar os grupos de permissões, faça upgrade do plano.</div>

      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="role.name"
          :disabled="!resourceAvailability.features.includes('custom_roles')">
        <ValidateMessage :error="validateErrors.name" />
      </div>

      <div
        v-for="(group, groupIndex) in groups"
        :key="groupIndex">
        <hr v-if="groupIndex > 0">
        <div class="form-group">
          <label><strong>{{ group.name }}</strong></label>
          <div
            v-for="(option, optionIndex) in group.options"
            :key="optionIndex"
            class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              :value="option.key"
              :id="option.key"
              v-model="role.permissions"
              :disabled="!resourceAvailability.features.includes('custom_roles')">
            <label
              class="form-check-label"
              :for="option.key">
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="role-form"
          class="btn btn-primary"
          v-if="resourceAvailability.features.includes('custom_roles')">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="role._id && removable && resourceAvailability.features.includes('custom_roles')"
          type="button"
          class="btn btn-danger"
          @click="deleteRole(role._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'RoleForm',
  components: {
  },
  props: [
    'initRole'
  ],
  data () {
    return {
      loading: false,
      role: this.defaultValues(this.initRole),
      validateErrors: {},
      groups: [{
        name: this.$t('Jobs and requisitions'),
        options: [{
          label: this.$t('View all job (non-confidential) and requisitions'),
          key: 'view_all_jobs'
        }, {
          label: this.$t('View all confidential jobs and requisitions'),
          key: 'view_all_confidentials'
        }, {
          label: this.$t('Create/edit jobs'),
          key: 'manage_jobs'
        }, {
          label: this.$t('Create/edit requisitions'),
          key: 'manage_requisitions'
        }, {
          label: this.$t('Reset approval workflow'),
          key: 'reset_approvalflows'
        }]
      }, {
        name: this.$t('Candidates'),
        options: [{
          label: this.$t('Manage, move, schedule, share candidates'),
          key: 'manage_candidates'
        }]
      }, {
        name: this.$t('Advertise'),
        options: [{
          label: this.$t('Publish jobs'),
          key: 'promote_job'
        }]
      }, {
        name: this.$t('Reports'),
        options: [{
          label: this.$t('View basic reports'),
          key: 'view_simple_report'
        }, {
          label: this.$t('View advanced reports'),
          key: 'view_advanced_report'
        }]
      }, {
        name: this.$t('Settings'),
        options: [{
          label: this.$t('Manage career pages'),
          key: 'manage_careerpages'
        }, {
          label: this.$t('Manage companies'),
          key: 'manage_companies'
        }, {
          label: this.$t('Manage departments'),
          key: 'manage_departaments'
        }, {
          label: this.$t('Manage members and permissions'),
          key: 'manage_members'
        }, {
          label: this.$t('Manage other settings such as tags, contracts, cancellation reasons...'),
          key: 'manage_settings'
        }]
      }, {
        name: this.$t('Billing'),
        options: [{
          label: this.$t('Manage billing'),
          key: 'manage_billing'
        }]
      }]
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    removable () {
      return this.role.administrator === false && this.role.members_count === 0
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        permissions: []
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveRole
    */
    saveRole (data) {
      if (data._id) this.updateRole(data)
      else this.createRole(data)
    },
    /*
    createRole
    */
    createRole (data) {
      this.loading = true

      this.$store
      .dispatch('createRole', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateRole
    */
    updateRole (data) {
      this.loading = true

      this.$store
      .dispatch('updateRole', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteRole (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteRole', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Role/RoleForm.vue